export const APP_ID =
  "73ec32b03dc9f2f4bc338de115d68090b01df72c9bb431d54f52046671c1a508";
